import { useCallback } from 'react'

import { Button, ButtonProps } from 'antd'
import { Icon } from 'govwell-ui'

import { useNotification } from 'src/components/shared/Notification/NotificationContext'
import { useNotifyGovWellSalesTeamAboutAIAssistant } from 'src/fetch/notify-sales-team'

type Props = {
  type: ButtonProps['type']
  text: string
  onClick?: () => void
}

const ContactGovWellAboutAIAssistantButton = (props: Props) => {
  const { type, text, onClick } = props
  const { mutateAsync: notifyGovWellSalesTeamAboutAIAssistant, isPending } =
    useNotifyGovWellSalesTeamAboutAIAssistant()
  const { notification } = useNotification()

  const handleClick = useCallback(async () => {
    await notifyGovWellSalesTeamAboutAIAssistant({})
    notification.success({
      message: `Thanks for your interest in GovWell's Community Assistant! Our team has been notified and will be in touch soon.`,
    })
    onClick?.()
  }, [notifyGovWellSalesTeamAboutAIAssistant, notification, onClick])
  return (
    <Button loading={isPending} icon={<Icon.FaMessage />} type={type} onClick={handleClick}>
      {text}
    </Button>
  )
}

export default ContactGovWellAboutAIAssistantButton
